import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, Optional } from '@angular/core';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
// import {AuthService} from './newauth/auth.service';
import {DashboardService} from './dashboard/dashboard.service'
import { DatePipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BrowserModule, DomSanitizer } from '@angular/platform-browser';
import { AppRoutingModule } from './app.routing';
// import { ComponentsModule } from './components/components.module';
import {MaterialModule} from './material.module'
//  import {LocationStrategy, HashLocationStrategy} from '@angular/common';
//import { SignaturePadModule } from 'angular2-signaturepad';
import { AppComponent } from './app.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './shared/authconfig.interceptor';
import { ChartsModule } from 'ng2-charts';
import { AuthModule } from './auth/auth.module';
import { AdminLayoutModule } from './layouts/admin-layout/admin-layout.module';
import { MAT_DATE_LOCALE } from '@angular/material/core';

import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { WhatsappMessageComponent } from './whatsapp-message/whatsapp-message.component';
import {Ng2TelInputModule} from 'ng2-tel-input';
import {DragDropModule} from '@angular/cdk/drag-drop';
import { OpticalModule } from './optical-module/optical-module.module';
import { IpdModule } from './ipd/ipd.module';
import { LabEntryModule } from './labentry/labentry.module';
import { CustomDomSanitizer } from './CustomDomSanitizer';
import { ImageAnalyzerComponent } from './image-analyzer/image-analyzer.component';
import { SharedModule } from './shared/shared.module';


@NgModule({
   imports: [
      BrowserModule,
     BrowserAnimationsModule,
      FormsModule,
      ReactiveFormsModule,
      HttpClientModule,
      RouterModule,
      AppRoutingModule,
      MaterialModule,
       AuthModule,
        AdminLayoutModule,
            SharedModule,
      //WebcamModule,
      ChartsModule,
      MatDialogModule,
      Ng2TelInputModule,
      DragDropModule,
      IpdModule,
      OpticalModule,
      LabEntryModule
   ],
  
  declarations: [ 
    AppComponent, WhatsappMessageComponent, ImageAnalyzerComponent
    //  AdminLayoutComponent

  ],

//   exports: [
//      PatientDocumentComponent
//  ],
  providers: [{provide: MAT_DATE_LOCALE, useValue: 'en-GB'},
  { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} },
  DashboardService,DatePipe,
  {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthInterceptor,
    multi: true
  },
 
  //  {provide: LocationStrategy, useClass: HashLocationStrategy}
  { provide: DomSanitizer, useClass: CustomDomSanitizer }
],
  bootstrap: [AppComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA // Tells Angular we will have custom tags in our templates
  ]
})
export class AppModule { }
